import { render, staticRenderFns } from "./remoteLoadSelect.vue?vue&type=template&id=64c7f297&scoped=true"
import script from "./remoteLoadSelect.vue?vue&type=script&lang=js"
export * from "./remoteLoadSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64c7f297",
  null
  
)

export default component.exports